import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllCategories } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

export const useRestoreAllCategories = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllCategoriesMutate,
        isPending: isRestoreAll,
    } = useMutation({
        mutationFn: restoreAllCategories,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore categories");
        },
    });

    return {
        restoreAllCategoriesMutate,
        isRestoreAll,
    };
};
